import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { NsKey } from 'enums/NsKey';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { Package } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ProductViewProvider } from './ProductViewContext';

export default function ProductsView() {
  const { t } = useDynamicTranslation([NsKey.Common])
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([
      ReferentialKey.Branch,
      ReferentialKey.Plateforme,
    ]))
  }, [dispatch])

  return (
    <ProductViewProvider>
      <SimpleDashboardContent>
        <GenericViewHeader
          title={t("SIDEBAR.PRODUCTS_MANAGER")}
          icon={Package}
        />
        <Outlet />
      </SimpleDashboardContent>
    </ProductViewProvider>
  );
}
